/**
 * @todo We need to temporarily make this validation a lot easier to pass.
 * In STOPEN-8482 we will make this validation stricter once again.
 */
export const CHAMBER_OF_COMMERCE_REGEX: RegExp = /^[a-zA-Z0-9]{1,17}$/
export const CHAMBER_OF_COMMERCE_REGEX_NL: RegExp = /^[0-9]{8}$/
